import { uuidSchema } from '@klopotun/contracts';
import { occurrencePayPath, paymentDetailPath, ROUTE } from '../config/routes.js';

/**
 * The two names a button under a bot message may put into the address (server side:
 * notifications/mini-app-link.ts). Anything else in the query string is Telegram's own.
 */
const OCCURRENCE_PARAMETER = 'occurrence';

const PAYMENT_PARAMETER = 'payment';

const uuidOf = (params: URLSearchParams, name: string): string | null => {
  const value = params.get(name);

  if (value === null) {
    return null;
  }

  return uuidSchema.safeParse(value).success ? value : null;
};

/**
 * Where the app opens, as the history the memory router starts with. A deep link lands on its
 * screen with the payment list underneath it, so the back button of Telegram leads somewhere
 * rather than nowhere; a plain launch is the list alone.
 */
export const launchEntriesOf = (search: string): string[] => {
  const params = new URLSearchParams(search);
  const occurrenceId = uuidOf(params, OCCURRENCE_PARAMETER);

  if (occurrenceId !== null) {
    return [ROUTE.attention, occurrencePayPath(occurrenceId)];
  }

  const paymentId = uuidOf(params, PAYMENT_PARAMETER);

  if (paymentId !== null) {
    return [ROUTE.attention, paymentDetailPath(paymentId)];
  }

  return [ROUTE.attention];
};
